import { render, staticRenderFns } from "./tos-body.vue?vue&type=template&id=0d586eee&scoped=true&"
import script from "./tos-body.vue?vue&type=script&lang=js&"
export * from "./tos-body.vue?vue&type=script&lang=js&"
import style0 from "./tos-body.vue?vue&type=style&index=0&id=0d586eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d586eee",
  null
  
)

export default component.exports